import { useContext } from "react";
import { Container } from "reactstrap";

//Common
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../common/DisplayData/DisplayData";
import ActionBar from "../../common/ActionBar/ActionBar";
import { BlockIcon, ActivateIcon } from "../../common/Icons";
import { Button } from "../../common/VFX-UI";

//App
import { ClaimContext } from "./ClaimContainer";
import useComponentGeneralStyles from "../../styles";
import { EMPTY_GUID } from "../../../utility/constants/constants";
import { ClaimViewProps } from "../../../types/claim";

const ClaimView = (props: ClaimViewProps) => {
  const {
    onClose,
    editAction,
    toggleActivateHandler,
    toggleDeactivateHandler,
  } = props;
  const claimContext = useContext(ClaimContext);
  const generalStyles = useComponentGeneralStyles();

  const claim = claimContext?.data;

  const state = claimContext?.claimTypes?.find(
    (claimType) =>
      (claimType as Record<string, string>)["value"] === claim?.claimTypeId
  );

  return (
    <FormBackGround>
      <FormHeader
        title="View Claim"
        chipLabel={claim?.isActive ? "Active" : "Inactive"}
        onClose={onClose}
        editActionHandler={claim?.isActive ? editAction : undefined}
      />
      <>
        <DisplayData text="Name" importedData={claim?.name}></DisplayData>
        <DisplayData
          text="Description"
          importedData={claim?.description}
        ></DisplayData>
        <DisplayData
          text="Claim Type"
          importedData={(state as Record<string, string>)["label"]}
        ></DisplayData>
        {claim?.id && claim?.id !== EMPTY_GUID && claim?.isActive && (
          <Container>
            <Button
              style={generalStyles.deleteButton}
              onClick={toggleDeactivateHandler}
            >
              <BlockIcon />
            </Button>
          </Container>
        )}
        {claim?.id && claim?.id !== EMPTY_GUID && !claim?.isActive && (
          <Container>
            <Button
              style={generalStyles.activateButton}
              onClick={toggleActivateHandler}
            >
              <ActivateIcon />
            </Button>
          </Container>
        )}
      </>
      <Container style={generalStyles.actionBarContainer}>
        <ActionBar cancelHandler={onClose} cancelText="Close"></ActionBar>
      </Container>
    </FormBackGround>
  );
};

export default ClaimView;
